<template>
    <section class="small-left">
        <div class="center gray">

            <lottie :name="'chapter-2/diagram-5-img-networks'" :width="500" :height="684" />

        </div>
        <div class="spacing space-between">

            <div>

                <h2>Session control in IMS networks</h2>

                <p>With SIP session control you can control every service in an all-IP network and enable new subscriber services, such as Vo5G, VoLTE and VoWiFi.</p>

            </div>

            <infobutton>
                Playing the role of CSCF functions handling initiation, registration, authentication and routing SIP sessions using standard 3GPP interfaces.
            </infobutton>

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    // ...

</style>